import * as yup from 'yup';

export const PasswordLoginSchema = yup.object({
  username: yup
    .string()
    .min(2, 'Username must be at least 3 Characters long.')
    .required('Username is required'),
  password: yup
    .string()
    .min(4, 'Password must be at least 4 Characters long.')
    .required('Password is required'),
});
export type IPasswordLogin = yup.InferType<typeof PasswordLoginSchema>;

export const InitialPasswordLoginSchema = yup
  .object({
    nursingHomeId: yup.string().required('ID of the NursingHome is missing'),
  })
  .concat(PasswordLoginSchema);
export type IInitialPasswordLogin = yup.InferType<typeof PasswordLoginSchema>;
